import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

export const devOnlyGuard = () =>
  environment.envName === 'dev' ? true : inject(Router).createUrlTree(['/']);
